
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { publicApiClient } from './apiClient';

const VerifyEmailChange = () => {
    const [status, setStatus] = useState('verifying');
    const [message, setMessage] = useState('');
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        const verify = async () => {
            const params = new URLSearchParams(location.search);
            const token = params.get('token');
            const requestId = params.get('requestId');

            if (!token || !requestId) {
                setStatus('error');
                setMessage('無効なリンクです。');
                return;
            }

            try {
                // Use publicApiClient because the user might not be logged in or session might be different
                const response = await publicApiClient.post('/v1/verify-email-change', { token, requestId });
                if (response.ok) {
                    setStatus('success');
                    setMessage('請求先メールアドレスの変更が完了しました。');
                    // Return to settings page since the login user remains the same
                    setTimeout(() => navigate('/settings/customer-info'), 3000);
                } else {
                    const data = await response.json();
                    setStatus('error');
                    setMessage(data.error || '検証に失敗しました。');
                }
            } catch (error) {
                setStatus('error');
                setMessage('エラーが発生しました。');
            }
        };

        verify();
    }, [location, navigate]);

    return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 p-4">
            <div className="bg-white p-8 rounded-lg shadow-md max-w-md w-full text-center">
                <h1 className="text-2xl font-bold mb-4">請求先メールアドレス変更確認</h1>
                {status === 'verifying' && <p className="text-gray-600">検証中...</p>}
                {status === 'success' && (
                    <div className="text-green-600">
                        <p className="text-lg mb-4">{message}</p>
                        <p className="text-sm text-gray-500">3秒後に自動的に移動します...</p>
                    </div>
                )}
                {status === 'error' && (
                    <div className="text-red-600">
                        <p className="text-lg mb-4">{message}</p>
                        <button
                            onClick={() => navigate('/settings/customer-info')}
                            className="bg-indigo-600 text-white px-4 py-2 rounded-md hover:bg-indigo-700"
                        >
                            戻る
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default VerifyEmailChange;
